module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Breadcrumbs', {
    staticClass: "blog",
    attrs: {
      "breadcrumbs": _vm.breadcrumbs
    }
  }, [_c('div', {
    staticClass: "row mx-0"
  }, [_c('BlogChips', {
    staticClass: "mb-4 col-auto px-0",
    attrs: {
      "chips": _vm.chips,
      "query-name": "event_type"
    }
  }), _c('BlogDateRanges', {
    staticClass: "mb-4 ms-auto col-auto px-0"
  }), (_vm.$store.getters.hasApiModulesMultiCop) ? _c('AppComboBox', {
    staticClass: "partner_cop ms-auto col-auto",
    attrs: {
      "data": _vm.getMultiCop,
      "placeholder": "Партнер ЦОПП"
    },
    on: {
      "input": _vm.updateData
    },
    model: {
      value: (_vm.multiCop),
      callback: function($$v) {
        _vm.multiCop = $$v
      },
      expression: "multiCop"
    }
  }) : _vm._e()], 1), (_vm.items && _vm.items.length) ? _c('PageBlogLayout', {
    key: _vm.key,
    attrs: {
      "articles": _vm.items
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;
        var index = ref.index;

        return [_c('ListItem', _vm._b({}, 'ListItem', item, false))]
      }
    }], null, false, 2944823394)
  }) : _vm._e(), _c('template', {
    slot: "after"
  }, [_c('Wrapper', {
    staticClass: "my-5 myWrapper"
  }, [_c('div', {
    staticClass: "d-flex row mx-0"
  }, [_c('div', {
    staticClass: "d-flex col"
  }), (_vm.pageCount > 1) ? _c('Paginator', {
    staticClass: "col",
    attrs: {
      "count": _vm.pageCount,
      "current": _vm.page,
      "max": 6
    }
  }) : _vm._e(), _c('div', {
    staticClass: "d-flex col"
  }, [_c('SelectCount', {
    staticClass: "ms-auto",
    attrs: {
      "options": _vm.LIMITS.map(function (el) { return ({
        text: el,
        value: el
      }); }),
      "value": _vm.limit,
      "text": "Новостей на странице"
    },
    on: {
      "change": _vm.pageLimitChange
    }
  })], 1)], 1)])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3eb3de17","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/blog/list/component.vue
// module id = 51f00a311c55b4400e86
// module chunks = 12